import React, { useState } from 'react';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { TextField } from '@mui/material';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Stack from '@mui/material/Stack';

import { getDoc, doc, setDoc, updateDoc, arrayUnion } from "firebase/firestore";
import { db } from '../firebase-config'
import { AppCTX } from '../data/AppContext'
import { defaultUserModel } from '../data/Models';
import { defaultTeamModel } from '../data/Models';


export default function TeamSignUp () {
  const {user, setUser} = React.useContext(AppCTX);
  const [createTeam, setCreateTeam] = useState(false);
  const [joinTeam, setJoinTeam] = useState(false);
  const [teamNameError, setTeamNameError] = useState('');
  const [teamFound, setTeamFound] = useState(false);
  const [nameError, setNameError] = useState('');
  const [userprofile, setUserprofile] = useState(defaultUserModel);

  const handleUserNameChange = (e) => {
    if(nameError.length>1 && e.target.value.length>0){
      setNameError('')
    }
    setUserprofile({...userprofile, name: e.target.value})
  }

  const handleTeamNameChange = (e) => {
    if(teamNameError.length>1 && e.target.value.length>0){
      setTeamNameError('')
    }
    const newValue = {...userprofile, teamName: e.target.value}
    setUserprofile(newValue)
  }

  const onCreateTeamSubmit = async () => {
    if(userprofile.teamName.length===0){
      setTeamNameError('Please enter a team name')
      return
    }
    if(userprofile.name.length===0){
      setNameError('Please enter your name')
      return
    }

    try {
      const docRef = doc(db, "teams", userprofile.teamName)
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        console.log("Document data:", docSnap.data());
        setTeamNameError('This name is already taken')
      } else {
        console.log('creating final payload', userprofile)
        const color = `#${Math.floor(Math.random()*16777215).toString(16)}`
        const updatedUserProfile = {...userprofile, color: color, memberType: 'closer'}
        // I created the user doc here
        await setDoc(doc(db, "users", user.uid), updatedUserProfile)
        // now I am creating the team doc
        await setDoc(doc(db, "teams", userprofile.teamName), {
          ...defaultTeamModel,
          teamLead: user.uid,
          members:[ updatedUserProfile ]
        })
        setUser({uid: user.uid, data: updatedUserProfile})
      }
    } catch(err){
      console.log(err)
    }
  }

  const onJoinTeamSubmit = async () => {
    if(userprofile.teamName.length===0){
      setTeamNameError('Please enter a team name')
      return
    }
    if(userprofile.name.length===0){
      setNameError('Please enter your name')
      return
    }
    try{
      let teamData = await searchTeam()
      let userfound = teamData.members.filter(member => member.name === userprofile.name)
      if (userfound.length>0){
        throw 'This user has already joined'
      }
      const color = `#${Math.floor(Math.random()*16777215).toString(16)}`
      let updatedUserProfile = {...userprofile, color: color }
      const teamRef = doc(db, "teams", userprofile.teamName);
      await updateDoc(teamRef, {
        members: [ ...teamData.members, updatedUserProfile ]
      });
      await setDoc(doc(db, "users", user.uid), updatedUserProfile)
      setUser({uid: user.uid, data:updatedUserProfile})
    } catch(err){
      if(err === 'This user has already joined'){
        setNameError(err)
      }
      console.log(err)
    }
  }

  const searchTeam = async () => {
    try {
      const docRef = doc(db, "teams", userprofile.teamName)
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setTeamFound(true);
        return docSnap.data()
      } else {
        setTeamNameError('No such team found')
      }
    }catch (err) {
      console.error(err);
      throw "Couldn't find team"
    }
  }

  if (createTeam) {
    return (
      <>
      <Box
        sx={{
          my: 8,
          mx: 4,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Create a Team
        </Typography>
        <Box sx={{ mt: 1 }}>
          <>
            <TextField
              margin="normal"
              required
              fullWidth
              label="Enter Team Name"
              name="verification-code"
              value={userprofile.teamName}
              error={teamNameError.length > 0}
              helperText={teamNameError}
              onChange={handleTeamNameChange}
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              label="Enter Full Name"
              name="verification-code"
              value={userprofile.name}
              onChange={handleUserNameChange}
              error={nameError.length > 0}
              helperText={nameError}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              onClick={onCreateTeamSubmit}
            >
              Create Team
            </Button>
            <Button
              type="submit"
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              onClick={() => setCreateTeam(false)}
            >
              Go back
            </Button>
          </>
        </Box>
      </Box>
    </>
    )
  } else if (joinTeam) {
    return (
      <div id="join-page">
        <Box
          sx={{
            my: 8,
            mx: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Join a Team
          </Typography>
          <Box sx={{ mt: 1 }}>
            <>
              {
                teamFound ?
                <Typography variant="h5" >
                  Team selected: {userprofile.teamName}
                </Typography>
                :
                <Stack direction="row" spacing={2}>
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    label="Enter Team Name"
                    name="verification-code"
                    autoFocus
                    error={teamNameError.length > 0}
                    helperText={teamNameError}
                    onChange={handleTeamNameChange}
                    value={userprofile.teamName}
                  />
                  <Button
                    type="submit"
                    variant="contained"
                    size="small"
                    className='search-team-btn'
                    onClick={searchTeam}
                  >
                    search
                  </Button>
                </Stack>
              }
              <TextField
                margin="normal"
                required
                fullWidth
                label="Your Name"
                name="verification-code"
                value={userprofile.name}
                onChange={handleUserNameChange}
                error={nameError.length > 0}
                helperText={nameError}
              />
              <ToggleButtonGroup
                color="primary"
                fullWidth
                value={userprofile.memberType}
                exclusive
                onChange={(e)=>{setUserprofile({...userprofile, memberType: e.target.value})}}
              >
                <ToggleButton value="setter">Setter</ToggleButton>
                <ToggleButton value="closer">Closer</ToggleButton>
              </ToggleButtonGroup>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                onClick={onJoinTeamSubmit}
              >
                Join Team
              </Button>
              <Button
                type="submit"
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                onClick={() => setJoinTeam(false)}
              >
                Go back
              </Button>
            </>
          </Box>
        </Box>
      </div>
    )
  } else {
    return (
      <>
        <Box
          sx={{
            my: 8,
            mx: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Your Team
          </Typography>
          <Box sx={{ mt: 1 }}>
            <>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                onClick={() => setCreateTeam(true)}
                sx={{ mt: 3, mb: 2 }}
              >
                Create a Team
              </Button>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                onClick={() => setJoinTeam(true)}
                sx={{ mt: 3, mb: 2 }}
              >
                Join a Team
              </Button>
            </>
          </Box>
        </Box>
      </>
    );
  };
};
